module.exports = __webpack_public_path__ + "public/images/captcha-circle-selected.95803796505729e1c91ba124235245cb.svg";